import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { BusinessArea } from '../masterdata/models/businessArea';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { MasterList } from '../masterdata/masterList-enum';
import { MaterialType, WellType } from '../carrier/carrier-enum';
import { HazardousType } from '../masterdata/hazardousType-enum';
import { SelectableHazardousType } from '../masterdata/selectable-hazardoustype';
import { SelectableLab } from '../carrier/selectable-lab';
import { MachineType, ProcessStepRuntime } from '../masterdata/models/machineType';
import { BmsProductName } from '../masterdata/models/BmsProductName';
import { Printer } from '../masterdata/models/printer';
import { SelectableProcessStep } from '../masterdata/models/SelectableProcessStep';
import { SelectableWellType } from '../masterdata/models/SelectableWellType';
import { SelectableCategory } from '../masterdata/models/SelectableCategory'
import { isEmpty } from 'rxjs/operators';
import { Chemical } from '../masterdata/models/chemical';
import { SelectableAssayType } from '../masterdata/models/SelectableAssayType';
import { Product } from '../masterdata/models/product';
import { PcrKitsType } from '../masterdata/models/pcrKitsType';
import { AssayType } from '../masterdata/models/assayType-enum';
import { ChemicalCategory } from '../masterdata/models/chemicalCategory-enum'
import { EchoConfig } from '../masterdata/models/echoConfig';
import { SalesItemTypeConfig } from '../masterdata/models/salesitemtype-config';
import { Template } from '../masterdata/models/template';
import { MdmProcessStepService } from '../mdm-process-step/mdm-process-step.service';
import { MachineFileTypeOptions, IOCapacityOptions } from './machine-options';
import { BBResponseContainer } from '../carrier/response-container';
import { Manufacturers } from '../masterdata/models/manufacturers';
import { WorkFlow, WorkFlowNGS } from '../masterdata/models/workFlow';
import { BeadChipProcessStep, ProcessStep } from '../models/process-step';
import { TagSystem } from '../masterdata/models/tag-system';
import { SelectItem } from 'primeng/api';
@Component({
  selector: 'app-crud-table',
  templateUrl: './crud-table.component.html',
  styleUrls: ['./crud-table.component.css']
})
//This component is used for displaying the table with the content coming from the parent component.
//It also includes crud operations for the data in the table
export class CrudTableComponent implements OnInit {

  @Input() masterLists: any[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() baOptions: BusinessArea[];
  @Input() masterListType: MasterList;
  @Input() countries: SelectItem[];
  @Input() hazardousTypeOptions: SelectableHazardousType[];
  @Input() machineTypesOptions: MachineType[];
  @Input() bmsProductNames: BmsProductName[];
  @Input() printerOptions: Printer[];
  @Input() processStepOptions: SelectableProcessStep[];
  @Input() bufferChemicalOptions: Chemical[];
  @Input() assayTypeOptions: SelectableAssayType[];
  @Input() productOptions: Product[];
  @Input() echoConfigOptions: EchoConfig[];
  @Input() sitConfigOptions: SalesItemTypeConfig[];
  @Input() maxRedoValues: SelectItem[];
  @Input() reactionOptionValues: SelectItem[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() workFlows: WorkFlowNGS[];
  @Input() tagSystemOptions: TagSystem[];
  @Input() sitConfigs: SalesItemTypeConfig[];
  @Input() isHandlingRequired: boolean = true;
  @Output() onDialogEvent = new EventEmitter<string>();
  @Output() onDataClicked = new EventEmitter<any>();
  
  labOption: LabMDM[] = [];
  isNotIpAddress = true;
  warningText: string;
  productMaxRedoValues: SelectItem[];
  pcrKits: PcrKitsType[];

  displayMasterListDialog: boolean;
  isNewMasterList: boolean;
  displayDeleteDialog: boolean = false;
  masterList: any;
  selectedMasterList: any;
  isActive: string = "active";
  isArray: string = "array";
  isNgs: string = "ngs";
  isDateRange = "dateRange";
  PlateID: string = "plateID";
  isLab: string = "lab";
  isHazardousType: string = "hazardousType";
  isBA: string = "businessArea";
  isProductType: string = "product";
  baTitle: string = "Business Areas";
  isDefaultLanguage: string = "defaultLanguage";
  isCountry: string = "countryName";
  isOriginalVolume: string = "originalVolume";
  isRemainingVolume: string = "remainingVolume";
  isMachineType: string = "type";
  isWellType: string = "containerType";
  isChemical: string = "chemical";
  isWorkflow: string = "workflow";
  isCategory: string = "category";
  isSalesItemType: string = "salesItemType";
  isTagSystem: string = 'tagSystem'
  isBmsKitProductName: string = "bmsKitProductName";
  isBmsTubeProductName: string = "bmsTubeProductName";
  isProcessStepPrinter: string = "printer";
  isProcessStepMachineType: string = "machineType";
  isProcessStepName: string = "name";
  isDefault: string = "default";
  isBuffer: string = "buffer";
  isAssayType: string = "assayType";
  isJobTime: string = "jobTime";
  isPremixed: string = "premixed";
  isAllowExcelUpload: string = "allowExcelUpload";
  isPcrKits:string ="pcrKits";
  isPlateSealing: string = "plateSealing";
  isHostAddress = 'hostAddress';
  isDefaultTemplate = 'template';
  isProductMaxRedo = "productMaxRedo";
  isMaxRedo = "maxRedo";
  isReactionOptionProtocol = "reactionOptionProtocol";
  isFileType: string = 'fileType';
  isIOCapacity: string = 'ioCapacity';
  isManufacturer: string = 'manufacturer';
  isNumberOfPC: string = "numberOfPC";
  isNumberOfNC: string = "numberOfNC";
  isReception: string = "reception";
  isLiquidHandling: string = "liquidHandling";
  isMeasurements: string = "measurements";
  isSequencer: string = "sequencer";
  isScanner: string = "scanner";
  isqubit : string = "qubit";
  isqPcr: string = "qPcr";
  newUI = "newUI";
  updateWeatherbys = "updateWeatherbys";
  activationCheck = "activationCheck";
  automatedReception = "automatedReception";
  qcScan = "qcScan";
  plateMerge = "plateMerge";
  samplesHaveBarcodes = "samplesHaveBarcodes";
  identifiers = "identifiers";
  upstream = "upstream";
  downstream = "downstream";
  tat = "tat";

  isReducedConfirmationTests: string = "reducedConfirmationTests";
  haveClippingMachine: string = "clippingMachine";
  isUnboxingInBatches: string = "unboxingInBatches"
  isAll384Controls: string = "all384Controls";
  isfasterFinderAutoRedo: string = "fasterFinderAutoRedo"
  isReportingOutsideBB: string = "reportingOutsideBB";
  isResultReportPerSender: string = "resultReportPerSender";
  beadchipID:string = "beadchipID";
  plateID:string="plateID";
  poolIDRegex: string = "poolIDRegex";
  isFlaTestProcess: string = "flaTestProcess";
  isNumberOfPositivePCRControls = "numberOfPositivePCRControls";
  isNumberOfNegativePCRControls = "numberOfNegativePCRControls";
  selectedLab: LabMDM;
  selectedBA: BusinessArea;
  selectedMachineType: MachineType;
  selectedHazardoustype: SelectableHazardousType;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedCountryCode: string;
  selectedLabName: string;
  selectedPlateID:string;
  selectedBeadchipID:string;
  selectedBaName: string;
  selectedMachineTypeName: string;
  selectedProdType: Product;
  selectedProdTypeName: string;
  popupTitle: string;
  seqConfigType = MasterList.SEQUENCER_CONFIG;
  ChemicalType = MasterList.CHEMICAL;
  chemicalLabs: SelectableLab[];
  selectedChemicalLab: SelectableLab;
  machineType = MasterList.MACHINE;
  processStep = MasterList.CARRIER_STATUS;
  product = MasterList.PRODUCT;
  wellTypes: SelectableWellType[];
  selectedWellType: SelectableWellType;
  selectedBufferChemical: Chemical;
  selectedAssayType: SelectableAssayType;
  categories: SelectableCategory[];
  selectedCategory: SelectableCategory;

  selectedEchoConfig: EchoConfig;
  echoConfigType: MasterList.ECHO_CONFIGURATION;

  selectedSalesItemTypeNames: string[] = [];
  selectedSitConfigArray: SalesItemTypeConfig[] = [];
  selectedPCRConfigArray: any;
  selectedTagSystemType: TagSystem;

  selectedNGSWorkFlowType: WorkFlowNGS;
  selectedBmsKitProductName: BmsProductName;
  selectedBmsTubeProductName: BmsProductName;
  selectedBufferName: string;

  selectedPrinterName: string;
  selectedPrinter: Printer;

  selectedProcessStep: SelectableProcessStep;

  printer = MasterList.PRINTER;
  selectedTemplate: Template;
  selectedTemplateName: string;
  labelTemplateOptions: Template[];
  selectedMaxRedo: number;
  selectedProductMaxRedo: number;
  reactionOption: string;

  manufacturersList: Array<Manufacturers>;
  machineManufacturerOptions: Array<Manufacturers>;
  machineFileTypeOptions: SelectItem[] = MachineFileTypeOptions;
  ioCapacityOptions: SelectItem[] = IOCapacityOptions;
  selectedMachineFileType: string;
  selectedMachineManufacturer: Manufacturers;
  ioCapacity: string;

  workFlowList = [];
  workFlowData: WorkFlow[] = [];
  ngsWorkFlowData: WorkFlowNGS[] = [];
  ngsWorkFlowOptions: any = [];
  setRuntimePopup: boolean = false;
  selectedMachineTypeStepRuntimes = [];
  selectedMachineTypeWorkflow: string = "";


  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private _msdmProcessStepService: MdmProcessStepService ) {
    this.wellTypes = [
      { label: WellType.WELL96, wellType: WellType.WELL96 },
      { label: WellType.WELL384, wellType: WellType.WELL384 }
    ];

    this.categories = [
      { label: ChemicalCategory.BUFFER, category: ChemicalCategory.BUFFER },
      { label: ChemicalCategory.OTHERS, category: ChemicalCategory.OTHERS }
    ];
  }

  openRuntimePopup(){
    this.selectedMachineTypeWorkflow = this.workFlowList[0].value;
    this.onChangeWorkflow();
    this.setRuntimePopup = true;
  }

  addWorkflowRuntimes(workflow: string){
    let stepRuntimes = []
    stepRuntimes.push(this.createStepRuntime("WGA + PGX", ProcessStep.WGA_AND_PGX, 0, workflow))
    stepRuntimes.push(this.createStepRuntime("Recombine DNA", ProcessStep.RECOMBINE_DNA, 0, workflow))
    stepRuntimes.push(this.createStepRuntime("Precipitate DNA", ProcessStep.PRECIPITATE_DNA, 0, workflow))
    stepRuntimes.push(this.createStepRuntime("Resuspend DNA", ProcessStep.RESUSPEND_DNA, 0, workflow))
    stepRuntimes.push(this.createStepRuntime("Load BeadChip", BeadChipProcessStep.LOADING ,0, workflow))
    stepRuntimes.push(this.createStepRuntime("Extend and Stain", BeadChipProcessStep.EXTENSION, 0, workflow))
    return stepRuntimes;
  }

  createStepRuntime(stepDisplayName: string, step: string, runtime: number, workflow: string): ProcessStepRuntime{
    var stepRuntime = new ProcessStepRuntime();
    stepRuntime.stepDisplayName = stepDisplayName;
    stepRuntime.step = step;
    stepRuntime.runtime = runtime;
    stepRuntime.workflow = workflow;
    return stepRuntime;
  }

  onChangeWorkflow(){
    if(!this.selectedMachineTypeWorkflow || this.selectedMachineTypeWorkflow==null){
      return;
    }
    this.masterList.stepRuntimes =  !this.masterList.stepRuntimes || this.masterList.stepRuntimes==null ? [] :  this.masterList.stepRuntimes;
    this.selectedMachineTypeStepRuntimes = this.masterList.stepRuntimes.filter(runtime => runtime.workflow===this.selectedMachineTypeWorkflow);
    if(!this.selectedMachineTypeStepRuntimes || this.selectedMachineTypeStepRuntimes.length==0){
      this.selectedMachineTypeStepRuntimes = this.addWorkflowRuntimes(this.selectedMachineTypeWorkflow);
    }
  }

  setRuntimes(){
    this.masterList.stepRuntimes = this.masterList.stepRuntimes.filter(runtime => runtime.workflow!==this.selectedMachineTypeWorkflow)
    this.masterList.stepRuntimes = this.masterList.stepRuntimes.concat(this.selectedMachineTypeStepRuntimes);
    this.masterList.stepRuntimes.sort((item1, item2) => item1.workflow.localeCompare(item2.workflow));
    this.setRuntimePopup = false
  }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.productMaxRedoValues = [{label:'1', value:1},{label:'2', value:2},{label:'3', value:3}];
    this.fetchWorkFlows();
  }

  fetchWorkFlows(){
    if(!this.checkSelectedLab){
      return;
    }
    this._masterDataService.getConfigList(this.checkSelectedLab.lab._id, "workflow", 0, 100, true).subscribe(
      results => {
        this.workFlowData = results.data;
        this.workFlowData.forEach(e=>{
          this.workFlowList.push({label: e.workFlowName, value: e.workFlowName});
        });
      }
    )
  }



  // This function is triggered on selecting the row in the table.
  // It opens a popup for modifying the data.
  onRowSelect(event) {
    if(!this.isHandlingRequired){
      this.onDataClicked.emit(event.data);
      return;
    }
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.selectedMachineTypeStepRuntimes = this.masterList.stepRuntimes
    this.selectedMachineTypeWorkflow = this.masterList.workflow
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedCountryCode = this.masterList.countryCode;
    this.getHazardousType(this.masterList.hazardousType);
    this.getSelectedBmsProductName(this.masterList.bmsKitProductName, this.masterList.bmsTubeProductName);
    this.getWellType(this.masterList.containerType);
    this.getAssayType(this.masterList.assayType);
    this.getCategory(this.masterList.category);
    this.selectedSitConfigArray = [];
    this.isJobTime = 'jobTime';
    this.selectedMaxRedo = this.masterList.maxRedo;
    this.selectedProductMaxRedo = this.masterList.productMaxRedo;
    this.reactionOption = this.masterList.reactionOptionProtocol;
    this.selectedMachineFileType = this.masterList.fileType;
    this.selectedTagSystemType = this.masterList.tagSystem;
    this.ioCapacity=this.masterList.ioCapacity;
  }

  // in product,sales item type options in the dropdown is based on the Lab selected
  //this is triggered when lab in selected from the drop down
  onLabSelect(lab) {
    if (this.masterListType == MasterList.PRODUCT) {
      this.selectedSitConfigArray = [];
      var labId = lab._id;
      this.getPcrKitsType();
      this._masterDataService.getSalesItemTypeFilteredByLab(labId).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("sits: ", results.data);
          this.sitConfigOptions = results.data;

          this.sitConfigOptions.forEach(config => {
            if (this.masterList && this.masterList.salesItemType){
            this.masterList.salesItemType.forEach(selectedConfig => {
              if(config._id == selectedConfig._id) {
                if (!this.containsObject(config, this.selectedSitConfigArray)) {
                  this.selectedSitConfigArray.push(config);
                }
              }
            })
            }
          })
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
          this.displayMasterListDialog = true;
        }
      );

      this._masterDataService.getConfigList(labId,"workflowngs",0,100).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("NGS Workflows: ", results.data);
          this.ngsWorkFlowOptions = results.data;

          this.ngsWorkFlowOptions.forEach(ngsWorkflow => {
            if (this.masterList && this.masterList.workflow && ngsWorkflow.workFlowName == this.masterList.workflow.workFlowName) {
              this.selectedNGSWorkFlowType = ngsWorkflow;
            }
          })
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
          this.displayMasterListDialog = true;
        }
      )

      this._masterDataService.getTagsystem(this.selectedLab).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.tagSystemOptions = results.data.filter(tagSystem => tagSystem.active == true);
          console.log("Tag Systems:", this.tagSystemOptions)
          this.tagSystemOptions.forEach(tagSystem => {
            if (this.masterList && this.masterList.tagSystem && tagSystem.tagSystemName == this.masterList.tagSystem.tagSystemName) {
              this.selectedTagSystemType = tagSystem;
            }
          })
        },
        error => {
          this.tagSystemOptions = [];
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

    }
    else if (lab._id != null && this.masterListType == MasterList.PRINTER) {
      this.labelTemplateOptions = [];
      this.selectedTemplate = null;
      this._masterDataService.getActiveTemplatesForLab(lab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.labelTemplateOptions = results.data;
          this.labelTemplateOptions.forEach(template => {
            if (this.masterList && this.masterList.template && template.id == this.masterList.template._id) {
              this.selectedTemplateName = template.templateName;
              this.selectedTemplate = template;
            }
          })
          if (!this.masterList || !this.masterList.template || this.selectedTemplateName != this.masterList.template.templateName)
            this.selectedTemplate = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          message.summary = 'Template Not Found';
          message.detail = "Barcode Template Not Found for Printer's Lab";
          this._messageService.addErrorMessage(message);
        });
    }

    else if (lab._id != null && this.masterListType == MasterList.MACHINE) {
      this.machineTypesOptions = [];
      this._masterDataService.getConfigList(this.checkSelectedLab.lab._id, "machineType", 0, 100, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.machineTypesOptions = results.data;
          this.machineTypesOptions.forEach(type => {
            if (this.masterList && this.masterList.type && type._id == this.masterList.type._id) {
              this.selectedMachineTypeName = this.masterList.type.name;
              this.selectedMachineType = type;
            }
          });
          if (!this.masterList || !this.masterList.type || this.selectedMachineTypeName != this.masterList.type.name)
            this.selectedMachineType = null;
          if (this.selectedMachineType) {
            this.handleMachineTypeChange(this.selectedMachineType);
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
      this._masterDataService.getConfigList(this.checkSelectedLab.lab._id, "machineManufacturer", 0, 100, true).subscribe(
        (response)=>{
          this.manufacturersList = response.data;
        }, (error)=>{
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      )
    }
  }

  // checks if obj(object) is present in the list(array of objects)
  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      var a = list[i];
      if (obj._id == (a._id)) {
        return true;
      }
    }
    return false;
  }
  //This function is triggered on click of add button.It displays the popup to add the data into the table.
  showDialogToAddMasterList() {
    if(!this.isHandlingRequired){
      this.onDialogEvent.emit("open");
      return;
    }
    this.isNewMasterList = true;
    this.masterList = {}
    this.displayMasterListDialog = true;
    this.selectedProductMaxRedo = 1;
    this.selectedPCRConfigArray = null;
    this.getActiveOptionsForDropdowns();
    this.selectedBA = null;
    this.selectedLab = null;
    this.selectedCountryCode = null;
    this.selectedProdType = null;
    this.selectedHazardoustype = null;
    this.selectedChemicalLab = null;
    this.selectedMachineType = null;
    this.selectedSitConfigArray = [];
    this.sitConfigOptions = [];
    this.selectedBmsKitProductName = null;
    this.selectedBmsTubeProductName = null;
    this.selectedProcessStep = null;
    this.selectedWellType = null;
    this.selectedAssayType = null;
    this.selectedBufferChemical = null;
    this.selectedCategory = null;
    this.selectedEchoConfig = null;
    this.isJobTime = null;
    this.isNotIpAddress = true;
    this.selectedTemplate = null;
    this.selectedMachineFileType = null;
    this.ioCapacity = null;
    this.selectedMachineManufacturer = null;
    this.selectedNGSWorkFlowType = null;
    this.selectedTagSystemType = null;
    this.selectedSitConfigArray = [];
  }

  getAssayType(assayType: AssayType) {
    if (assayType != null && assayType != undefined) {
      switch (assayType.toString()) {
        case "HS_LARGE_FRAGMENT": {
          this.selectedAssayType = { label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT }
          break;
        }
        case "HS_NGS_FRAGMENT": {
          this.selectedAssayType = { label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT }
          break;
        }
        case "SS_NGS_FRAGMENT": {
          this.selectedAssayType = { label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT }
          break;
        }

      }
    }
  }

  getHazardousType(hazardousType: string) {
    switch (hazardousType) {
      case "Explosives": {
        this.selectedHazardoustype = { label: "Explosives", hazardousType: HazardousType.EXPLOSIVES }
        break;
      }
      case "Acute Toxicity": {
        this.selectedHazardoustype = { label: "Acute Toxicity", hazardousType: HazardousType.ACUTE_TOXICITY }
        break;
      }
      case "Aspiration Hazard": {
        this.selectedHazardoustype = { label: "Aspiration Hazard", hazardousType: HazardousType.ASPIRATION_HAZARD }
        break;
      }
      case "Compressed Gases": {
        this.selectedHazardoustype = { label: "Compressed Gases", hazardousType: HazardousType.COMPRESSED_GASES }
        break;
      }
      case "Corrosive": {
        this.selectedHazardoustype = { label: "Corrosive", hazardousType: HazardousType.CORROSIVE }
        break;
      }
      case "Flamable Liquids": {
        this.selectedHazardoustype = { label: "Flamable Liquids", hazardousType: HazardousType.FLAMMABLE_LIQUIDS }
        break;
      }
      // case "HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT": {
      //   this.selectedHazardoustype = { label: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT, hazardousType: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT }
      //   break;
      // }
      case "Oxidising Liquids": {
        this.selectedHazardoustype = { label: "Oxidising Liquids", hazardousType: HazardousType.OXIDISING_LIQUIDS }
        break;
      }
      case "Toxic Irration": {
        this.selectedHazardoustype = { label: "Toxic Irration", hazardousType: HazardousType.TOXIC_IRRATION }
        break;
      }

    }
  }

  getSelectedBmsProductName(bmsKitProductName, bmsTubeProductName) {
    if (bmsKitProductName == "" || bmsKitProductName == null || bmsKitProductName == undefined)
      this.selectedBmsKitProductName = null;
    else {
      this.bmsProductNames.forEach(element => {
        if (bmsKitProductName != null && element.name == bmsKitProductName) {
          this.selectedBmsKitProductName = element;
        }
      })
    }
    if (bmsTubeProductName == "" || bmsTubeProductName == null || bmsTubeProductName == undefined)
      this.selectedBmsTubeProductName = null;
    else {
      this.bmsProductNames.forEach(element => {
        if (bmsTubeProductName != null && element.name == bmsTubeProductName) {
          this.selectedBmsTubeProductName = element;
        }
      })
    }
  }
  //==> Get Process Step code moved to mdm-process-step.component
  getWellType(wellType: string) {
    switch (wellType) {
      case WellType.WELL96: {
        this.selectedWellType = { label: WellType.WELL96, wellType: WellType.WELL96 }
        break;
      }
      case WellType.WELL384: {
        this.selectedWellType = { label: WellType.WELL384, wellType: WellType.WELL384 }
        break;
      }
    }
  }

  getCategory(category: string) {
    switch (category) {
      case ChemicalCategory.BUFFER: {
        this.selectedCategory = { label: ChemicalCategory.BUFFER, category: ChemicalCategory.BUFFER }
        break;
      }
      case ChemicalCategory.OTHERS: {
        this.selectedCategory = { label: ChemicalCategory.OTHERS, category: ChemicalCategory.OTHERS }
        break;
      }
    }
  }
  //This function is used to save the data into the Db.
  saveMasterList() {
    if(!this.masterLists || this.masterLists==null){
      this.masterLists = []
    }

    let masterLists = [...this.masterLists];

    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }

    // this.displayMasterListDialog = false;
  }

  //This function deletes the data from the db
  deleteMasterList() {
    let index = this.masterLists.indexOf(this.selectedMasterList);
    this.masterLists = this.masterLists.filter((val, i) => i != index);
    this.masterList = null;
    this.displayMasterListDialog = false;
    this.displayDeleteDialog = false;
  }

  //This function is used to clone the list of masterdata.
  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }
  //if a valid lab name is existing ,the editing for that fiels is disabled
  isLabValid(fieldName) {
    if (this.masterListType == MasterList.LAB) {
      if (this.masterList._id == null || this.masterList._id == isEmpty() || this.masterList._id == undefined) {
        return false;
      } else if (fieldName == "name") {
        return true;
      }
    } else {
      return false;
    }
  }

  //Updates the list of masterData
  updateMasterData(masterLists) {
    switch (this.masterListType) {
      case MasterList.LAB: {
        this.setLabDetails();
        this._masterDataService.updateLab(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            if (results.data.mix2SeqLabId == 0) {
              results.data.mix2SeqLabId = null;
            }
            console.log("labs:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;

      }
      case MasterList.MACHINE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.type = new MachineType();
        this.masterList.type = this.selectedMachineType;
        this.masterList.fileType = this.selectedMachineFileType;
        this.masterList.ioCapacity = this.ioCapacity;
        this.masterList.manufacturer = this.getManufactureName();
        this._masterDataService.updateConfig(this.selectedLab, this.masterList, "machine").subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("machines:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;

      }
      case MasterList.PRINTER: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        if (this.selectedTemplate != null) {
          this.masterList.template = this.selectedTemplate;
          this.masterList.template._id = this.selectedTemplate.id;
        }
        else
          this.masterList.template = null;
        this._masterDataService.updatePrinter(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("printers:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.BUSINESS_AREA: {
        this._masterDataService.updateBusinessArea(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("business Area:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.MACHINE_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this._masterDataService.updateConfig(this.selectedLab, this.masterList, "machineType").subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("machineTypes:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.SALES_ITEM_TYPE: {
        this.masterList.lab = this.selectedLab;
        this.masterList.bmsKitProductName = this.selectedBmsKitProductName ? this.selectedBmsKitProductName.name : null;
        this.masterList.bmsTubeProductName = this.selectedBmsTubeProductName ? this.selectedBmsTubeProductName.name : null;
        this.masterList.maxRedo = this.selectedMaxRedo;
        this._masterDataService.updateSITConfiguration(this.selectedLab._id, this.masterList._id, this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.PRODUCT: {
        this.masterList.lab = this.selectedLab;
        this.masterList.workflow = this.selectedNGSWorkFlowType;
        this.masterList.salesItemType = this.selectedSitConfigArray;
        this.masterList.tagSystem = this.selectedTagSystemType;
        this._masterDataService.updateConfig(this.selectedLab, this.masterList, 'product').subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
    }
  }

  //Saves the list of masterData
  saveMasterData(masterLists) {
    switch (this.masterListType) {
      case MasterList.LAB: {
        this.setLabDetails();
        this._masterDataService.addLab(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            if (results.data.mix2SeqLabId == 0) {
              results.data.mix2SeqLabId = null;
            }
            masterLists = [...this.masterLists];
             console.log("labs:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;           
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.MACHINE: {
        this.masterList.lab = this.selectedLab;
        this.masterList.type = new MachineType();
        this.masterList.type = this.selectedMachineType;
        this.masterList.fileType = this.selectedMachineFileType;
        this.masterList.ioCapacity = this.ioCapacity;
        this.masterList.manufacturer = this.getManufactureName();
        this._masterDataService.saveConfig(this.selectedLab, this.masterList, "machine").subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("machines:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.PRINTER: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        if (this.selectedTemplate != null) {
          this.masterList.template = this.selectedTemplate;
          this.masterList.template._id = this.selectedTemplate.id;
        }
        else
          this.masterList.template = null;
        this._masterDataService.addPrinter(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("printers:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      //==> Process Step code moved to mdm-process-step.component
      case MasterList.BUSINESS_AREA: {
        this._masterDataService.addBusinessArea(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("business Area:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.MACHINE_TYPE: {
        this.masterList.lab = this.selectedLab;
        this._masterDataService.saveConfig(this.selectedLab, this.masterList, "machineType").subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("machineTypes:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.SALES_ITEM_TYPE: {
        this.masterList.lab = this.selectedLab;
        this.masterList.bmsKitProductName = this.selectedBmsKitProductName ? this.selectedBmsKitProductName.name : null;
        this.masterList.bmsTubeProductName = this.selectedBmsTubeProductName ? this.selectedBmsTubeProductName.name : null;
        this.masterList.maxRedo = this.selectedMaxRedo;
        this._masterDataService.addSITConfiguration(this.selectedLab._id, this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("SIT-Config --> :", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            if (this.masterList.jobTime) {
              this.restartJobService();
            }
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.PRODUCT: {
        this.masterList.lab = this.selectedLab;
        this.masterList.workflow = this.selectedNGSWorkFlowType;
        this.masterList.salesItemType = this.selectedSitConfigArray;
        this.masterList.tagSystem = this.selectedTagSystemType;
        this._masterDataService.saveConfig(this.selectedLab, this.masterList, 'product').subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("Products --> :", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            if (this.masterList.jobTime) {
              this.restartJobService();
            }
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
    }
  }

  //gets the active options for dropdowns
  getActiveOptionsForDropdowns() {
    this.labOption = [];
    if (MasterList.LAB != this.masterListType && MasterList.BUSINESS_AREA != this.masterListType)
      this._masterDataService.getLabs(true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active labs:", results.data);
          this.labOptions = results.data;
          this.labOptions.forEach(lab => {
            if (this.checkSelectedLab &&
              this.checkSelectedLab.lab.name == lab.name &&
              this.checkSelectedLab.lab.businessArea.name == "Applied Genomics") {
              this.labOption.push(lab);
            }

            if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
              this.selectedLabName = this.masterList.lab.name;
              this.selectedLab = lab;
            }
          });

          if (this.checkSelectedLab && this.checkSelectedLab.lab.businessArea.name == "Applied Genomics") {
            this.labOptions = this.labOption;
          }
          if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
            this.selectedLab = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
    if (MasterList.LAB == this.masterListType)
      this._masterDataService.getBusinessAreas(true).subscribe(
        results => {
          if (!results) {
            return;
          }
         if (this.masterList[this.isUnboxingInBatches] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isUnboxingInBatches] = true;
          }
          if (this.masterList[this.isNumberOfPC] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isNumberOfPC] = 1;
          }
          if (this.masterList[this.isNumberOfNC] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isNumberOfNC] = 1;
          }
          if (this.masterList[this.isNumberOfNegativePCRControls] == undefined || this.masterList[this.isNumberOfNegativePCRControls] == null) {
            this.masterList[this.isNumberOfNegativePCRControls] = 1;
          }
          if (this.masterList[this.isNumberOfPositivePCRControls] == undefined || this.masterList[this.isNumberOfPositivePCRControls] == null) {
            this.masterList[this.isNumberOfPositivePCRControls] = 1;
          }
          console.log("Active business Areas:", results.data);
          this.baOptions = results.data;
          this.baOptions.forEach(ba => {
            if (this.masterList && this.masterList.businessArea && ba._id == this.masterList.businessArea._id) {
              this.selectedBaName = this.masterList.businessArea.name;
              this.selectedBA = ba;
            }
          })
          if (!this.masterList || !this.masterList.businessArea || this.selectedBaName != this.masterList.businessArea.name)
            this.selectedBA = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

    if (MasterList.PRINTER == this.masterListType) {
      this.labelTemplateOptions = [];
      if (this.masterList.lab != null) {
        this.selectedLab = this.masterList.lab;
        this.onLabSelect(this.selectedLab);
      }
    }

    if (MasterList.MACHINE == this.masterListType) {
      if (this.masterList.lab != null) {
        this.selectedLab = this.masterList.lab;
        this.onLabSelect(this.selectedLab);
      }
    }

    if (MasterList.PRODUCT == this.masterListType) {
      if (this.masterList.lab != null) {
        this.selectedLab = this.masterList.lab;
        this.onLabSelect(this.selectedLab);
      }
    }
  }

  setLabDetails() {
    this.masterList.businessArea = new BusinessArea();
    this.masterList.businessArea = this.selectedBA;
    this.masterList.defaultLanguage = navigator.languages ? navigator.languages[0] : (navigator.language);
    this.masterList.countryCode = this.selectedCountryCode;
    if (this.masterList.mix2SeqLabId == 0) {
      this.masterList.mix2SeqLabId = null;
    }

  }
  setChemicalDetails() {
    this.masterList.lab = this.selectedLab;
    this.masterList.type = MaterialType.Chemical;
    this.masterList.category = this.selectedCategory.label.toString();
    if (this.selectedHazardoustype != null)
      this.masterList.hazardousType = this.selectedHazardoustype.label;
  }

  //Returns true if the save button has to be disabled for the editing popup
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    switch (this.masterListType) {
      case MasterList.LAB: {
        if (!this.selectedCountryCode || !this.selectedBA || !this.masterList.name || !this.masterList.city)
          return true;
        return false;
      }
      case MasterList.MACHINE: {
        if (!this.masterList.name || !this.selectedLab || !this.selectedMachineType || !this.masterList.barcode || !this.isNotIpAddress)
          return true;
        return false;
      }
      case MasterList.PRINTER: {
        if (!this.masterList.hostAddress || !this.selectedLab || !this.isNotIpAddress)
          return true;
        return false;
      }
      case MasterList.BUSINESS_AREA: {
        return !this.masterList.name
      }
      case MasterList.MACHINE_TYPE: {
        return (!this.masterList.name || !this.selectedLab)
      }
      case MasterList.SALES_ITEM_TYPE: {
        return (!this.masterList.sitKey || !this.selectedLab)
      }
      case MasterList.PRODUCT: {
        return (!this.masterList.name || !this.selectedLab || !this.selectedNGSWorkFlowType || !(this.selectedSitConfigArray.length!=0) || !this.selectedTagSystemType);
      }
      default: return true;
    }
  }

  //Handling the change in job timing
  changeJobTimeForProduct() {
    if (confirm("You have modified job time for the product! do you want to proceed?")) {
      this.saveMasterList();
      this.restartJobService();
    } else {
      this.displayMasterListDialog = false;
    }
  }

  //The Job restart caller function
  restartJobService() {
    
  }

  //To run job for a product on demand
  runJobForProduct() {
    
  }

  ipNameEnforce(hostAddressValue) {
    let givenIpValue = hostAddressValue.target.value;
    // tslint:disable-next-line:max-line-length
    if (givenIpValue.match('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:)?(:[0-9]+)?$')) {
      this.isNotIpAddress = false;
      this.warningText = 'Please enter Domain Name in place of IP address.';
    } else {
      this.isNotIpAddress = true;
    }
  }

  setSubType() {
    if (this.masterList.subType.trim() == '')
      this.masterList.subType = null;
  }

  handleMachineTypeChange(machineType: MachineType) {
    const { _id } = this.selectedLab;
    const { name } = machineType;
    this.machineManufacturerOptions = this.manufacturersList.filter(manufacturer => manufacturer.machineType===name);
    const selectedManufacture: Manufacturers = this.machineManufacturerOptions.find((manufacture: Manufacturers) => manufacture.manufacturerName === this.masterList.manufacturer);
    this.selectedMachineManufacturer = selectedManufacture ? selectedManufacture : null;
  }

  private getManufactureName(){
    if(this.selectedMachineManufacturer){
      return typeof this.selectedMachineManufacturer === 'object' ? this.selectedMachineManufacturer.manufacturerName : this.selectedMachineManufacturer;
    }
    return null;
  }

  private getPcrKitsType()
  {
    const { _id } = this.selectedLab;
    this._masterDataService.getSenderSpecificKits(_id,true).subscribe((pcrType:BBResponseContainer)=>{
       const uniquePcrKits=new Set<string>(this.masterList.pcrKits);
       this.pcrKits= pcrType.data.pcr.map((p:string)=>({pcrKey:p}));
       this.selectedPCRConfigArray=this.pcrKits.filter((kit:any)=>uniquePcrKits.has(kit.pcrKey));
    });
    
  }
  validationForPlateID(exisit: boolean) {
    this.masterList.plateID.forEach(positiveRegex => {
      if (positiveRegex.regexFormat == undefined || positiveRegex.regexFormat.trim() == "") {
        exisit = true;
      }
    });
    return exisit;
  }

  getValuesFromLists(data: Array<Object> = []){
    const values : Array<any> = new Array();
    data.forEach( object => {
      if (object instanceof String){
        values.push(object)
      }else{
        let value = "[ "
        Object.keys(object).forEach(key => {
          value += ` ${key} : ${object[key]} ;`
        })
        value += " ]";
        values.push(value);
      }
    })

    return values
  }
}
